import React from 'react';
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Megaphone, Users, BarChart3 } from "lucide-react";

const pillars = [
  {
    icon: Megaphone,
    title: "Generate Demand",
    description: "We drive high-quality leads through ads, SEO, and content.",
  },
  {
    icon: Users,
    title: "Capture & Nurture",
    description: "We ensure every lead is tracked, responded to instantly, and nurtured through CRM, email, and automation.",
  },
  {
    icon: BarChart3,
    title: "Convert & Optimize",
    description: "We turn leads into booked customers using booking systems, follow-ups, and performance tracking.",
  },
];

export const WhatWeDoDifferently = () => {
  return (
    <section className="py-20 px-4 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold mb-4 text-foreground text-center"
        >
          We Build Systems, Not Just Campaigns
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-lg text-muted-foreground text-center mb-12 max-w-3xl mx-auto"
        >
          Instead of focusing only on traffic, we build complete lead-to-revenue systems that ensure every opportunity is captured, followed up, and converted.
        </motion.p>
        <div className="grid md:grid-cols-3 gap-6">
          {pillars.map((pillar, i) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
            >
              <Card className="h-full border-border bg-card hover:shadow-lg transition-shadow">
                <CardContent className="pt-8 pb-6 text-center">
                  <div className="inline-flex p-4 rounded-full bg-primary/10 mb-5">
                    <pillar.icon className="h-7 w-7 text-primary" />
                  </div>
                  <h3 className="text-xl font-semibold mb-3 text-foreground">{pillar.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{pillar.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
